module.exports = __webpack_public_path__ + "img/insta.b3cdaee5.svg";